import AccountKeyDetails from './AccountKeyDetails'

export default AccountKeyDetails
